import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import StoreDescription from "./StoreDescription.js";
const StoreDescriptionContainer = ({ storeName, description, ...rest }) => {
  const { getFormattedLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      title: getFormattedLabel("stores.page.details.description.title", {
        labelData: {
          store: storeName
        }
      })
    }),
    [storeName, getFormattedLabel]
  );
  return /* @__PURE__ */ React.createElement(StoreDescription, { labels, description, ...rest });
};
export {
  StoreDescriptionContainer as default
};
//# sourceMappingURL=StoreDescriptionContainer.js.map
